import { getStudentBgColor } from "../../misc/constants";
import { MainUser } from "../../types";

type AvatarProps = {
    user: MainUser
}

export const Avatar = ({ user }: AvatarProps) => {
    const bgClass = getStudentBgColor(user.json_saved_data?.firstname?.length);

    if (!user.profile_image) {
        return (
            <div className={`bg-${bgClass} w-9 h-9 rounded-full flex flex-row justify-center items-center`}>
                <span className="font-bold text-[15px] leading-[18px] text-white">
                    {user.json_saved_data?.lastname?.at(0)?.toUpperCase()}
                    {user.json_saved_data?.firstname?.at(0)?.toUpperCase()}
                </span>
            </div>
        )
    }
    return (
        <img alt={user.json_saved_data?.email} src={user.profile_image} className="w-9 h-9 rounded-full" />
    )
}